import React from "react";
import { Container, Typography, Box } from "@mui/material";
import PageTitle from "../Components/PageTitle";
import Navbar from "../Components/Navbar";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PrivacyPolicyBanner from "../assets/PrivacyPolicy.png";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Privacy Policy - Shree Mangalam School"
        description="Learn about our commitment to protecting your privacy and personal information at Shree Mangalam School."
        url="/privacy-policy"
        keywords="privacy policy, data protection, personal information, Shree Mangalam School privacy"
      />
      <Header image={PrivacyPolicyBanner} alt="Privacy Policy Banner" />
      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Privacy Policy
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At <strong>Shree Mangalam School</strong>, we value your
          privacy. This policy outlines how we collect, use, and protect your
          personal information when you visit our website or interact with our
          services.
        </Typography>

        <Box mt={4}>
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              color: "#AD1C86",
            }}
            gutterBottom
          >
            1. Information We Collect
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
          >
            We may collect the following types of information:
          </Typography>
          <ul>
            <li>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                Personal details (e.g., name, email, phone number)
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                Academic and enrollment details
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                Browser and device data
              </Typography>
            </li>
          </ul>
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              color: "#AD1C86",
            }}
            gutterBottom
          >
            2. How We Use Your Information
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
          >
            Your information is used to:
          </Typography>
          <ul>
            <li>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                Process admissions and registrations
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                Send updates and important notifications
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                Improve our services and website experience
              </Typography>
            </li>
          </ul>
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              color: "#AD1C86",
            }}
            gutterBottom
          >
            3. Data Security
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
            paragraph
          >
            We take data security seriously and implement appropriate technical
            and organizational measures to protect your personal data.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              color: "#AD1C86",
            }}
            gutterBottom
          >
            4. Sharing of Information
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
            paragraph
          >
            We do not sell, rent, or share your personal data with third parties
            except as required by law or with your explicit consent.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              color: "#AD1C86",
            }}
            gutterBottom
          >
            5. Changes to This Policy
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
            paragraph
          >
            We may update this privacy policy from time to time. All changes
            will be posted on this page with a revised date.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              color: "#AD1C86",
            }}
            gutterBottom
          >
            6. Contact Us
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
            paragraph
          >
            If you have any questions about this privacy policy, please contact
            us at:
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
          >
            Email: shreemangalamacademy11@gmail.com
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              lineHeight: "1.8rem",
            }}
          >
            Address: Shree Mangalam School, Jaipur-Gudha State Highway (Just on by pass) In Gudha Gorji Rajasthan pin 333022
          </Typography>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
